"use client";
import { RefObject, ReactElement, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Container, DataList, Flex, Button } from "@radix-ui/themes";
import { useTranslations } from "next-intl";
import { getApiHostname, getParamsValue } from "@/util/paramutil";
import {
  AlertProps,
  ChangeDataIdFunction,
  ClipboardProp,
  ClipboardPropCommon,
  DataParams,
  FetchCommonParams,
  FetchUrlParams,
  TransitionType,
} from "@/components/layout/layoutType";
import {
  DataColumn,
  DataCols,
  DataElement,
  DataInputParams,
  DataInputCommonParams,
  DataGuideType,
} from "@/components/layout/input/inputType";
import { fetchHost, fetchStatusText, fetchUtil } from "@/util/fetchutil";
import { checkDebug, Debug } from "@/util/debug";
import DataInput from "./dataInput";

//import * as Form from "@radix-ui/react-form";
import { FormInstance, useForm } from "antd/es/form/Form";
import { Form, Popconfirm } from "antd";
import { Dayjs } from "dayjs";
import { getDataStatusText, getNoData } from "@/util/datautil";
import { cn } from "@/lib/utils";
import {
  checkDisplay,
  convertInputTypeValue,
  convertSubListToFormData,
  focusFormField,
  getColsFields,
  getColsGroups,
  getDayjsValueStr,
  getInputDirectTarget,
  getLabelInputName,
  getMatchingData,
  getParamFields,
  getParamsFieldsCommon,
  getSubListData,
  getSubListTarget,
  runFormFunction,
  setScaledData,
} from "../input/inputFunction";
import { getCodeGroups } from "@/util/code";
import { useRouter } from "next/navigation";
import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";
import { addUserAuthSelect, getUserAuthSelect } from "@/util/authutil";
import { getIntArray, sortDataColumn } from "@/util/arrayutil";
import { AlertContext } from "@/components/context/alertContext";
import { checkEmpty, checkEmptyValue, getJsonFromStr, getStrFromJson, linkFieldConvert } from "@/util/stringutil";

import { Skeleton } from "@radix-ui/themes";
import Icon from "@/components/common/icon/icon";
import { appRouterPush, checkSafari, isNativePlatform } from "@/util/apputil";
import { enableScroll } from "@/util/checkMobile";
import { getMenuProps } from "@/components/common/menu/menu";
import { Capacitor } from "@capacitor/core";
import { isIOS } from "react-device-detect";
import { alertClose, alertLoading, alertOffline } from "../list/defaultType";
import { url } from "inspector";
// import dynamic from "next/dynamic";
// const Skeleton = dynamic(() => import("@radix-ui/themes").then((mod) => mod.Skeleton), { ssr: false });
// const Icon = dynamic(() => import("@/components/common/icon/icon"), { ssr: false });
// const DataInput = dynamic(() => import("./dataInput"), { ssr: false });

const dv = require("@datas/default.json");
const guide_type_name = "guide_type";
const useGuideSimple: boolean = false;
const getFetchUrlOption = (
  dataId: string | undefined,
  option: any,
  fetchUrl: string | undefined,
  fetchHost: boolean | undefined,
  fetchUrlAfter: string | undefined,
  nowDataMode: string | undefined,
  listColLinkField?: string | string[],
  listColLinkFieldJoin?: string | undefined,
  uriField?: string[] | undefined,
  base64Field?: string[] | undefined,
  checkDataMode?: boolean | undefined,
): { url: string; option: any; dataId: string | undefined } => {
  let temp_dataId = dataId;
  let temp_fetchUrl = fetchUrl ?? "";
  const lastFetchUrl = temp_fetchUrl.charAt(temp_fetchUrl.length - 1);
  const temp_option = { ...option };
  if (listColLinkField && (listColLinkField instanceof Array || uriField || base64Field)) {
    Debug("temp_option", temp_option);
    temp_dataId = "";
    temp_option.method = "POST";
    temp_option.headers = { "Content-Type": "application/json" };
    const joinStr = listColLinkFieldJoin ?? "_";
    const pk_arr = dataId && typeof dataId === "string" && dataId.indexOf(joinStr) > 0 ? dataId.split(joinStr) : [dataId];
    Debug("dataId", dataId, pk_arr);
    const temp_body = temp_option.body ? (typeof temp_option.body === "string" ? JSON.parse(temp_option.body) : temp_option.body) : {};
    const tempListColLinkField = typeof listColLinkField === "string" ? [listColLinkField] : listColLinkField;
    tempListColLinkField.forEach((key, index) => {
      if (pk_arr && pk_arr[index]) {
        temp_body[key] = linkFieldConvert(key, pk_arr[index], uriField, base64Field);
      }
    });
    if (checkDataMode && nowDataMode === "edit") {
      temp_body["mode"] = "edit";
    }
    temp_option.body = JSON.stringify(temp_body);
    if (lastFetchUrl === "/") {
      temp_fetchUrl = temp_fetchUrl.substring(0, temp_fetchUrl.length - 1);
    }
  } else {
    if (listColLinkField !== undefined && lastFetchUrl !== "/") {
      temp_fetchUrl += "/";
    }
  }
  const temp_url = ((fetchHost ?? dv.fetchHost) ? getApiHostname() : "") + temp_fetchUrl + temp_dataId + (fetchUrlAfter ?? "");
  Debug("temp_url, temp_option", temp_url, temp_option);
  const edit_mode =
    !checkDataMode || nowDataMode !== "edit" || listColLinkField instanceof Array
      ? ""
      : temp_url.indexOf("?") > 0
        ? "&mode=edit"
        : "?mode=edit";

  return { url: temp_url + edit_mode, option: temp_option, dataId };
};

export function initDataCols(cols: DataCols | undefined): DataColumn[] {
  return initDataColCheck(cols) ?? [{ field: "" }];
}
export function initDataColCheck(cols: DataCols | undefined): DataColumn[] | undefined {
  if (cols instanceof Array) {
    return cols.map((item) => {
      if (typeof item == "string") {
        return { field: item };
      } else {
        return item;
      }
    });
  } else if (cols instanceof Object) {
    const keys = Object.keys(cols);
    return keys.map((key) => {
      cols[key];
      return { ...cols[key], field: key };
    });
  } else {
    return undefined;
  }
}
const getDataMode = (id?: string, modeField?: string, defaultMode?: string) => {
  if (modeField) {
    return getParamsValue(modeField) ?? defaultMode ?? "view";
  } else {
    if (id === "write") {
      return id;
    } else {
      return getParamsValue("mode") ?? defaultMode ?? "view";
    }
  }
};
export const scrollToDataPosition = (
  containerId?: string,
  dataScrollTo?: string,
  obj?: HTMLElement,
  dataScrollMargin?: number,
  animate?: boolean,
) => {
  const header = document.querySelector("body:not(.menuBottom) header.mainHeader > div") as HTMLElement;
  const dataContainer = obj
    ? obj
    : dataScrollTo
      ? document.querySelector(dataScrollTo)
      : containerId
        ? document.getElementById(containerId)
        : undefined;
  if (dataContainer) {
    const ab_top =
      dataContainer.getBoundingClientRect().top - (header ? header.offsetHeight : 0) + window.scrollY - (dataScrollMargin ?? 0);
    if (ab_top < window.scrollY) {
      //Debug("scrollTo : " + ab_top + "," + window.scrollY);
      if (animate ?? true) {
        window.scrollTo({
          top: ab_top,
          behavior: "smooth",
        });
      } else {
        window.scrollTo({
          top: ab_top,
        });
      }
    }
  }
};
const getDataId = (param: string | number): string | undefined => {
  if (typeof param == "string") {
    return getParamsValue(param) ?? undefined;
  } else if (typeof param == "number") {
    const path_split = window.location.pathname.split("/");
    return path_split.length >= param ? path_split[param] : undefined;
  } else {
    return undefined;
  }
};

const editPage = (
  useDefaultId?: boolean,
  changeDataId?: ChangeDataIdFunction,
  dataId?: string,
  modeField?: string,
  historyPush?: boolean,
) => {
  if (changeDataId && (useDefaultId || dataId)) {
    changeDataId(dataId ?? "", useDefaultId, "edit", modeField, historyPush);
  }
};

const listPage = (
  useDefaultId: boolean,
  changeDataId?: ChangeDataIdFunction,
  dataId?: string,
  modeField?: string,
  historyPush?: boolean,
) => {
  if (changeDataId) {
    changeDataId("", useDefaultId, "", modeField, historyPush);
  }
};
const viewPage = (
  form: FormInstance<any>,
  useDefaultId: boolean,
  changeDataId?: ChangeDataIdFunction,
  dataId?: string,
  modeField?: string,
  historyPush?: boolean,
) => {
  ResetFields(form);
  if (changeDataId && (useDefaultId || dataId)) {
    // const removeFields = params.writeMatching && dataMode == "write" ? Object.keys(params.writeMatching) : undefined;
    if (modeField == null && dataId === "write") {
      changeDataId("", useDefaultId, "", modeField);
    } else {
      changeDataId(dataId ?? "", useDefaultId, "", modeField, historyPush);
    }
  }
};
const clearPage = (params: DataParams) => {
  if (params.setTimer && params.timer) {
    params.setTimer({ timer: params.timer, start: undefined });
  }
  if (params.formMemo) {
    const keys = Object.keys(params.formMemo);
    keys.forEach((key) => {
      if (params.formMemo) {
        delete params.formMemo[key];
      }
    });
  }
};
const cancelPage = (form: FormInstance<any>, params: DataParams, dataId?: string) => {
  clearPage(params);
  viewPage(form, params.useDefaultId ?? false, params.changeDataId, dataId, params.modeField, params.historyPush);
};

const saveData = (form: FormInstance<any>) => {
  form.submit();
};
const undoData = (form: FormInstance<any>, cols: DataColumn[]) => {
  ResetFields(form);
};
const ResetFields = (form: FormInstance<any>) => {
  form.resetFields();
};
const getScaledData = (
  save_cols: Record<string, DataInputCommonParams>,
  obj: any,
  dataMode: string,
  formFunction: Record<string, Record<string, Function>> | undefined,
) => {
  const keys = Object.keys(save_cols);
  keys.forEach((key) => {
    const temp_col = save_cols[key];

    //const subData_result = getSubListData(params.formFunction, temp_col, key, obj, true);
    if (temp_col !== undefined && temp_col !== null) {
      if (
        !(temp_col.saveData ?? true) ||
        (dataMode === "write" && !(temp_col.writeData ?? true)) ||
        (dataMode === "edit" && !(temp_col.editData ?? true))
      ) {
        delete obj[key];
      } else if (temp_col.subList) {
        getSubListData(formFunction, temp_col, key, obj, true, true);
        const target = getSubListTarget(temp_col, key);
        const temp_values = target ? obj[target] : undefined;
        if (temp_values && temp_values instanceof Array) {
          const subData_cols = getParamFields({ ...temp_col, values: undefined });

          const subData_labelInputName = getLabelInputName({ ...temp_col, values: undefined });
          if (subData_labelInputName && temp_col.labelInput) {
            subData_cols[subData_labelInputName] = temp_col.labelInput;
            getParamsFieldsCommon(temp_col.labelInput, subData_cols);
          }

          if (subData_cols) {
            delete subData_cols[key];
            temp_values.forEach((temp_value) => {
              Object.keys(subData_cols).forEach((sub_key) => {
                const temp_sub_col = subData_cols[sub_key];
                if (
                  !(temp_sub_col.saveData ?? true) ||
                  (dataMode === "write" && !(temp_sub_col.writeData ?? true)) ||
                  (dataMode === "edit" && !(temp_sub_col.editData ?? true))
                ) {
                  delete temp_value[sub_key];
                }
              });
            });
          }
        }
      } else {
        setScaledData(temp_col, key, obj);
      }
    }
  });
  return obj;
};
const getChangedData = (save_cols: Record<string, DataInputCommonParams>, data: any, obj: any, linkFields?: string | string[]) => {
  const keys = Object.keys(obj);
  const changePassKeys: Record<string, any> = {};
  //const subListKeys = Object.keys(save_cols).filter((key) => save_cols[key].subList);
  keys.forEach((key) => {
    const temp_data = obj[key];
    const org_data = data[key];
    // if (key == "edit_at" || key == "rgst_at") Debug(temp_data, org_data, typeof temp_data);
    if (((temp_data === null || temp_data === undefined) && (org_data === null || org_data === undefined)) || temp_data === org_data) {
      if (save_cols[key] && save_cols[key].changePass) {
        changePassKeys[key] = obj[key];
      }
      delete obj[key];
    } else {
      // Debug(key, temp_data, org_data);
      if (temp_data === undefined || temp_data === "") {
        obj[key] = null;
      }
    }
  });
  //Debug(subListKeys);
  Object.keys(save_cols).forEach((key) => {
    const temp_col = save_cols[key];
    const target = getSubListTarget(temp_col, key);
    if (target && temp_col.subList) {
      // const pk = temp_col.subListKeys;
      // const sub_values = obj[target];
      const temp_values = target ? obj[target] : undefined;
      const org_values = target ? data[target] : undefined;
      const subData_cols = getParamFields({ ...temp_col, values: undefined });

      const subData_labelInputName = getLabelInputName({ ...temp_col, values: undefined });
      if (subData_labelInputName && temp_col.labelInput) {
        subData_cols[subData_labelInputName] = temp_col.labelInput;
        getParamsFieldsCommon(temp_col.labelInput, subData_cols);
      }

      const sub_keys = typeof temp_col.subListKeys === "string" ? [temp_col.subListKeys] : temp_col.subListKeys;
      let sub_chagned = false;
      if (checkEmpty(sub_keys) || (checkEmpty(temp_values) && checkEmpty(org_values))) {
        // Debug(temp_values);
      } else {
        if (sub_keys && org_values !== undefined && org_values instanceof Array) {
          org_values.forEach((org_value) => {
            const org_keys: Record<string, any> = {};
            sub_keys.forEach((sub_key) => {
              org_keys[sub_key] = org_value[sub_key];
            });

            if (temp_values !== undefined && temp_values instanceof Array) {
              const check = temp_values.some((temp_value) => {
                const temp_keys: Record<string, any> = {};
                sub_keys.forEach((sub_key) => {
                  temp_keys[sub_key] = temp_value[sub_key];
                });
                if (sub_keys.every((key) => org_keys[key] === temp_keys[key])) {
                  const temp_UPList: string[] = [];
                  const temp_changePass: Record<string, any> = {};
                  Object.keys(temp_value).forEach((temp_key) => {
                    if (temp_key !== "UPList" && !sub_keys.includes(temp_key)) {
                      const check_org_value = org_value[temp_key];
                      const check_temp_value = temp_value[temp_key];
                      if ((checkEmpty(check_org_value) && checkEmpty(check_temp_value)) || check_org_value === check_temp_value) {
                        if (subData_cols[key] && subData_cols[key].changePass) {
                          temp_changePass[temp_key] = temp_value[temp_key];
                        }
                        delete temp_value[temp_key];
                      } else {
                        temp_UPList.push(temp_key);
                      }
                    }
                  });
                  if (temp_UPList.length > 0) {
                    if (!sub_chagned) {
                      sub_chagned = true;
                    }
                    temp_value["UPList"] = temp_UPList;
                    if (!checkEmpty(temp_value) && !checkEmpty(temp_changePass)) {
                      Object.keys(temp_changePass).forEach((key) => {
                        temp_value[key] = temp_changePass[key];
                      });
                    }
                  } else {
                    temp_value["CHECKList"] = 1;
                  }
                  return true;
                } else {
                  return false;
                }
              });
              if (!check) {
                if (!sub_chagned) {
                  sub_chagned = true;
                }
                obj[target].push({ ...org_value, DEList: 1 });
              }
            }
          });
        }
      }
      if (temp_values instanceof Array) {
        obj[target] = temp_values.filter((item) => item["CHECKList"] === undefined);
        if (checkEmpty(obj[target])) {
          delete obj[target];
        }
      }
    }
  });

  const change_keys = Object.keys(obj);
  if (change_keys.length > 0) {
    if (linkFields) {
      if (linkFields instanceof Array) {
        linkFields.forEach((key) => {
          obj[key] = data[key];
        });
      } else {
        obj[linkFields] = data[linkFields];
      }
    }
    if (!checkEmpty(changePassKeys)) {
      Object.keys(changePassKeys).forEach((key) => {
        obj[key] = changePassKeys[key];
      });
    }
    obj["UPList"] = change_keys;
    return obj;
  } else {
    return undefined;
  }
};
const getCheckData = (params: DataParams, save_cols: Record<string, DataInputCommonParams>, obj: any) => {
  const check_result: { field: string; message: string; value: number; label: string } = { field: "", message: "", value: 0, label: "" };
  const keys = Object.keys(save_cols);
  const sublist_data: Record<string, any[]> = {};
  keys.forEach((key) => {
    const temp_col = save_cols[key];
    if (temp_col.subList) {
      const subData_result = getSubListData(params.formFunction, temp_col, key, obj, false, true);
      const sublist_target = getSubListTarget(temp_col, key);
      if (sublist_target) {
        sublist_data[sublist_target] = subData_result;
      }
    }
  });
  Debug(sublist_data);
  const check = keys.some((key) => {
    const temp_col = save_cols[key];
    const temp_val = obj[key];
    if (temp_col.subListTarget) {
      const temp_sublist_data = sublist_data[temp_col.subListTarget];
      if (temp_col.required) {
        if (temp_sublist_data && temp_sublist_data instanceof Array) {
          const check = temp_sublist_data.some((value, index) => {
            if (checkEmpty(value[key])) {
              check_result.field = key + "_" + index;
              check_result.message = "field_required";
              if (typeof temp_col.label === "string") {
                check_result.label = temp_col.label;
              } else {
                check_result.label = key;
              }
              return true;
            }
            return false;
          });
          if (check) {
            return true;
          }
        }
      }
    } else if (
      checkEmpty(temp_val) ||
      temp_val === null ||
      temp_val === undefined ||
      (typeof temp_val === "string" && temp_val.trim() === "")
    ) {
      if (temp_col.subList && (temp_col.minLength !== undefined || temp_col.maxLength !== undefined)) {
        const sublist_target = getSubListTarget(temp_col, key);
        const subData_result = sublist_target ? (sublist_data[sublist_target] ?? []) : [];
        if (temp_col.minLength !== undefined && temp_col.minLength > subData_result.length) {
          check_result.field = key;
          check_result.message = "sublist_minLength";
          check_result.value = temp_col.minLength;
          check_result.label = key;
          return true;
        }
        if (temp_col.maxLength !== undefined && temp_col.maxLength < subData_result.length) {
          check_result.field = key;
          check_result.message = "sublist_maxLength";
          check_result.value = temp_col.maxLength;
          check_result.label = key;
          return true;
        }
      }
      if (temp_col.required) {
        check_result.field = key;
        check_result.message = "field_required";
        if (typeof temp_col.label === "string") check_result.label = temp_col.label;
        Debug(temp_col);
        return true;
      }
    } else {
      if (temp_col.inputDirect) {
        const target = typeof temp_col.inputDirect === "string" ? temp_col.inputDirect : temp_col.inputDirect.target;
        if (
          ((typeof temp_val === "string" && temp_val === dv.input_direct) ||
            (temp_val instanceof Array && temp_val.includes(dv.input_direct))) &&
          (target === null || target === undefined || (typeof target === "string" && target.trim() === ""))
        ) {
          check_result.field = target;
          check_result.message = "field_required";
          if (typeof temp_col.label === "string") check_result.label = temp_col.label;
          return true;
        }
      }

      if (temp_col.valueType === "number" || temp_col.inputType === "inputNumber") {
        const temp_num = Number(temp_val);
        if (isNaN(temp_num) && !checkEmpty(temp_val)) {
          Debug(key, temp_col, temp_val, obj[key]);
          check_result.field = key;
          check_result.message = "field_NaN";
          return true;
        } else {
          const scale_temp_num = temp_num;
          // temp_col !== undefined && temp_col.scale !== null && temp_col.scale !== undefined && temp_num !== undefined
          //   ? temp_num * temp_col.scale
          //   : temp_num;

          if (temp_col.minValue !== undefined && Number(temp_col.minValue) > scale_temp_num) {
            check_result.field = key;
            check_result.message = "field_minValue";
            check_result.value = Number(temp_col.minValue);
            if (typeof temp_col.label === "string") check_result.label = temp_col.label;
            return true;
          }
          if (temp_col.minValue !== undefined && Number(temp_col.maxValue) < scale_temp_num) {
            check_result.field = key;
            check_result.message = "field_maxValue";
            check_result.value = Number(temp_col.maxValue);
            if (typeof temp_col.label === "string") check_result.label = temp_col.label;
            return true;
          }
        }
      }
      if (temp_col.minLength !== undefined || temp_col.maxLength !== undefined) {
        const temp_length = Buffer.byteLength(temp_val + "");
        if (temp_col.minLength !== undefined && temp_col.minLength > temp_length) {
          check_result.field = key;
          check_result.message = "field_minLength";
          check_result.value = temp_col.minLength;
          if (typeof temp_col.label === "string") check_result.label = temp_col.label;
          return true;
        }
        if (temp_col.maxLength !== undefined && temp_col.maxLength < temp_length) {
          check_result.field = key;
          check_result.message = "field_maxLength";
          check_result.value = temp_col.maxLength;
          if (typeof temp_col.label === "string") check_result.label = temp_col.label;
          return true;
        }
      }
    }
    return false;
  });

  if (check) {
    return check_result;
  } else {
    if (params.saveCheck) {
      return params.saveCheck(save_cols, obj);
    } else {
      return null;
    }
  }
};
const formFinish = (
  form: FormInstance<any>,
  router: AppRouterInstance,
  t: TransitionType,
  ta: TransitionType,
  data: any,
  dataMode: string,
  dataId: string | undefined,
  obj: any,
  params: DataParams,
  alertContext: AlertProps,
) => {
  const alert_p = alertContext.setProp;
  if (alert_p) {
    const save_cols = getColsFields(params.dataCols);
    const temp_obj = obj ? JSON.parse(JSON.stringify(obj)) : obj;
    const check_obj = getCheckData(params, save_cols, temp_obj);
    const org_obj = checkDebug() ? JSON.parse(JSON.stringify(obj)) : obj;
    if (check_obj) {
      Debug("check value error : ", check_obj, save_cols);
      const fieldName = t(check_obj.label !== "" ? check_obj.label : check_obj.field);
      alert_p({
        open: true,
        title: ta("validation_error"),
        description: ta(check_obj.message, { field: fieldName, value: check_obj.value }),
        useCancel: false,
        useOk: true,
        okFunction: () => {
          setTimeout(() => {
            alert_p(alertClose);
          }, dv.setTimeoutDelay);
          focusFormField(form, check_obj.field);
        },
      });
    } else {
      const scaled_obj = getScaledData(save_cols, obj, dataMode, params.formFunction);
      Debug("scaled data", obj, JSON.parse(JSON.stringify(scaled_obj)));
      const save_obj =
        dataMode === "write" ? scaled_obj : getChangedData(save_cols, data, scaled_obj, params.dataPks ?? params.listColLinkField);
      if (save_obj && (params.uriField || params.base64Field)) {
        const keys: string[] = [];
        if (params.uriField) keys.push(...params.uriField);
        if (params.base64Field) keys.push(...params.base64Field);
        keys.forEach((key) => {
          if (save_obj[key]) {
            save_obj[key] = linkFieldConvert(key, save_obj[key], params.uriField, params.base64Field);
          }
        });
      }
      //Debug("save data", save_obj ? JSON.parse(JSON.stringify(save_obj)) : undefined);
      Debug("save data", data, org_obj, save_obj, save_cols);
      const mode_fetch = dataMode === "write" ? params.createSaveFetch : params.updateSaveFetch;
      const common_fetch = params.saveFetch;
      const save_fetch = common_fetch || mode_fetch ? { ...common_fetch, ...mode_fetch } : undefined;
      if (!navigator.onLine) {
        alert_p(alertOffline(ta));
      } else if (!save_fetch) {
        alert_p({
          open: true,
          title: ta("underconstruction"),
          description: ta("underconstruction_text"),
          useCancel: false,
          useOk: true,
          okFunction: () => {},
        });
      } else if (save_obj === null || save_obj === undefined || Object.keys(save_obj).length <= 0) {
        Debug("change values is zero");
        alert_p({
          open: true,
          title: ta("save"),
          description: ta("save_not_changed"),
          useCancel: false,
          useOk: true,
          //okFunction: () => {},
        });
      } else {
        const pr_obj = save_fetch.dataProcess ? save_fetch.dataProcess(obj) : obj;
        Debug("change values of form: ", org_obj, pr_obj);
        alert_p({
          open: true,
          title: ta("save"),
          description: ta(params.saveDetail ?? "save_detail"),
          useCancel: true,
          useOk: true,
          okClose: false,
          okFunction: () => {
            if (save_fetch && save_fetch.fetchUrl && save_fetch.fetchUrl !== "") {
              setTimeout(() => {
                alert_p(alertLoading);
                const temp_url =
                  ((save_fetch.fetchHost ?? dv.fetchHost) ? (getApiHostname() ?? "") : "") +
                  save_fetch.fetchUrl +
                  (save_fetch.fetchUrlAfter ?? "");
                const body_data = pr_obj ? JSON.stringify(pr_obj) : undefined;
                const save_option = { ...(save_fetch.fetchOption ?? dv.fetchOption) };
                const option = {
                  method: "POST",
                  headers: { "Content-Type": "application/json; charset=utf-8" },
                  ...save_option,
                  body: body_data,
                };
                Debug(temp_url, save_option, option);
                fetchUtil(
                  temp_url,
                  option,
                  params.page.auth,
                  (data: any) => {
                    if (data.status === "OK") {
                      Debug(data);
                      const successResult = save_fetch.successFunction
                        ? typeof save_fetch.successFunction !== "string"
                          ? save_fetch.successFunction(data, alert_p)
                          : save_fetch.successFunction
                        : true;
                      // alert_p({
                      //   open: false,
                      //   loading: false,
                      // });

                      setTimeout(() => {
                        alert_p({
                          open: true,
                          title: ta("save"),
                          description: ta(params.saveOkDesc ?? "save_ok"),
                          useCancel: false,
                          useOk: true,
                          okFunction: () => {
                            alert_p(alertClose);
                            setTimeout(() => {
                              if (typeof successResult === "string") {
                                // router.push(successResult);
                                clearPage(params);
                                appRouterPush(router, successResult);
                              } else if (successResult) {
                                if (params.useList ?? true) {
                                  if (params.dataFunction && params.dataFunction["setListReload"]) {
                                    params.dataFunction["setListReload"]();
                                  }
                                  if (dataMode === "write") {
                                    clearPage(params);
                                    listPage(
                                      params.useDefaultId ?? false,
                                      params.changeDataId,
                                      dataId,
                                      params.modeField,
                                      params.historyPush,
                                    );
                                  } else {
                                    cancelPage(form, params, dataId);
                                  }
                                } else {
                                  cancelPage(form, params, dataId);
                                }
                              }
                            }, dv.setTimeoutDelay);
                          },
                        });
                      }, 150);
                    } else {
                      const nodata_text = data.description ?? fetchStatusText(data.status, false);
                      Debug(nodata_text);
                      alert_p({
                        open: true,
                        title: ta("error"),
                        description: t(nodata_text),
                        useCancel: false,
                        useOk: true,
                        okFunction: () => {},
                      });
                    }
                  },
                  (error: any) => {
                    const errorResult = save_fetch.errorFunction
                      ? typeof save_fetch.errorFunction !== "string"
                        ? save_fetch.errorFunction(error, alert_p)
                        : save_fetch.errorFunction
                      : true;
                    if (typeof errorResult === "string") {
                      appRouterPush(router, errorResult);
                      // router.push(errorResult);
                    } else if (errorResult) {
                      alert_p({
                        open: true,
                        title: ta("error"),
                        description: ta("error_text"),
                        useCancel: false,
                        useOk: true,
                        okFunction: () => {},
                      });
                    }
                  },
                );
              }, 50);
            }
          },
        });
      }
    }
  }
};
const removeDataAlert = (ta: TransitionType, form: FormInstance<any>, params: DataParams, alertContext: AlertProps) => {
  const id = params.dataIdField ? form.getFieldValue(params.dataIdField) : form.getFieldsValue();
  const alertFunction = alertContext.setProp; //params.alertFunction;
  if (alertFunction) {
    alertFunction({
      open: true,
      title: ta("delete"),
      description: ta("delete_detail"),
      useCancel: true,
      useOk: true,
      okFunction: () => {
        setTimeout(() => {
          alertFunction(alertLoading);
        }, 50);
        setTimeout(() => {
          alertFunction(alertClose);
        }, 1000);
      },
    });
  }
};
const removeData = (ta: TransitionType, form: FormInstance<any>, params: DataParams, alertContext: AlertProps) => {
  const alertFunction = alertContext.setProp; //params.alertFunction;
  if (alertFunction) {
    // alertFunction({
    //   open: true,
    //   loading: true,
    // });removeData
    setTimeout(() => {
      alertFunction({
        open: true,
        loading: false,
        title: ta("delete"),
        description: ta("delete_ok"),
        useCancel: false,
        useOk: true,
      });
      // setTimeout(() => {
      //   alertFunction({
      //     open: false,
      //     loading: false,
      //   });
      // }, 1000);
    }, 500);
  }
};

export default function Data(params: DataParams) {
  const router = useRouter();
  const containerId = "data-" + (params.dataName ?? "default");
  const dataName = params.dataName ? params.dataName + "_" : "Default_";
  const formName = params.dataName ? params.dataName + "_Form" : "Default_Form";
  const option = params.fetchOption ?? dv.fetchOption;
  const t = useTranslations(params.dataTransGroup ?? "contents");
  // const [init, setInit] = useState(false);
  const init = useRef(false);
  const runInit = useRef(false);
  // const [runInit, setRunInit] = useState(false);
  const [dataError, setDataError] = useState(false);
  const [cols, setCols] = useState<DataColumn[]>(initDataCols(params.dataCols));
  const [selectWithFields, setSelectWithFields] = useState<string[] | undefined>(undefined);
  const [tempValue, setTempValue] = useState<any>(params.tempValue !== undefined ? { ...params.tempValue } : {});
  const [dataId, setDataId] = useState(params.dataId);
  const [dataMode, setDataMode] = useState<string>(params.dataMode ?? params.defaultMode ?? "view");
  const [data, setData] = useState<any>({});
  const [dataLoading, setDataLoading] = useState<boolean>(false);
  const [subData, setSubData] = useState<any>({});
  const [tempData, setTempData] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [form] = useForm();
  const [reload, setReload] = useState(false);
  // const [editCheck, setEditCheck] = useState(false);
  const editCheck = useRef(false);
  const [classList, setClassList] = useState<string[]>(params.dataFormClassDefault ?? []);
  const [pathname, setPathname] = useState(params.pathname);
  const [guideType, setGuideType] = useState<DataGuideType>("FULL");

  const resetFunction = useRef<Record<string, Function>>({});
  const ta = useTranslations("alert");
  const alertContext = useContext(AlertContext);

  const dataFormFinish = (obj: any) => {
    formFinish(form, router, t, ta, data, dataMode, dataId, obj, params, alertContext);
  };
  const setSubDataTarget = (target: string, data: any) => {
    const temp_sub_data = subData ?? {};
    temp_sub_data[target] = data;
    setSubData(temp_sub_data);
  };
  if (form && params.setForm) {
    //Debug(form);
    params.setForm(form);
  }
  if (params.setSubData) {
    params.setSubData(setSubDataTarget);
  }

  const getListClickArg = (fetch: (FetchUrlParams & FetchCommonParams) | undefined, ...arr: any) => {
    const arrs = [...arr];
    if (arrs.length > 0 && typeof arrs[0] === "string") {
      return {
        ...getFetchUrlOption(
          arr[0],
          fetch?.fetchOption ?? dv.fetchOption,
          fetch?.fetchUrl,
          fetch?.fetchHost ?? false,
          fetch?.fetchUrlAfter,
          dataMode,
          params.listColLinkField,
          params.listColLinkFieldJoin,
          params.uriField,
          params.base64Field,
          params.checkDataMode,
        ),
        title: arrs.length > 1 ? arr[1] : undefined,
        arr: arrs.length > 2 ? arrs.slice(2) : undefined,
      };
    } else {
      return arrs;
    }
    // return arrs.length > 0 && typeof arrs[0] === "string"
    //   ? {
    //       ...getFetchUrlOption(
    //         arr[0],
    //         fetch?.fetchOption ?? dv.fetchOption,
    //         fetch?.fetchUrl,
    //         fetch?.fetchHost ?? false,
    //         fetch?.fetchUrlAfter,
    //         dataMode,
    //         params.listColLinkField,
    //         params.listColLinkFieldJoin,
    //         params.uriField,
    //         params.base64Field,
    //         params.checkDataMode,
    //       ),
    //       title: arrs.length > 1 ? arr[1] : undefined,
    //       arr: arrs.length > 2 ? arrs.slice(2) : undefined,
    //     }
    //   : arrs;
  };

  if (params.dataFunction) {
    params.dataFunction["getData"] = () => {
      return data;
    };
    params.dataFunction["getDataMode"] = () => {
      return dataMode;
    };
    params.dataFunction["getCols"] = () => {
      return getColsGroups(params.dataCols);
    };
    params.dataFunction["setFormClass"] = (addClassName: string | string[], removeClassName: string | string[]) => {
      // Debug("addFormClass");
      const addClassList = (typeof addClassName === "string" ? [addClassName] : addClassName).filter((item) => !classList.includes(item));
      const removeClassList = typeof removeClassName === "string" ? [removeClassName] : removeClassName;
      const filterClassList = classList.filter((item) => !removeClassList.includes(item));
      if (addClassList.length > 0) {
        return setClassList([...filterClassList, ...addClassList]);
      } else {
        return setClassList([...filterClassList]);
      }
    };
    params.dataFunction["addFormClass"] = (className: string | string[]) => {
      // Debug("addFormClass");
      const addClassList = (typeof className === "string" ? [className] : className).filter((item) => !classList.includes(item));
      if (addClassList.length > 0) {
        return setClassList([...classList, ...addClassList]);
      }
    };
    params.dataFunction["removeFormClass"] = (className: string | string[]) => {
      // Debug("removeFormClass");
      const removeClassList = typeof className === "string" ? [className] : className;
      const filterClassList = classList.filter((item) => !removeClassList.includes(item));
      if (classList.length !== filterClassList.length) {
        return setClassList(filterClassList);
      }
    };
    params.dataFunction["setTempData"] = (str: string, data: any) => {
      const newData = { ...tempData };
      newData[str] = data;
      setTempData(() => newData);
    };
    params.dataFunction["getTempData"] = (str: string) => {
      return tempData[str];
    };

    if (params.listClick) {
      const listClick = params.listClick;
      const listClickFetch = params.listClickFetch;
      if (listClick instanceof Function) {
        if (dataMode !== "view" || (dataMode === "view" && !checkEmpty(dataId)))
          params.dataFunction[dataMode + "ListClick"] = (...arg: any) => {
            listClick(getListClickArg(listClickFetch, ...arg));
          };
      } else if (listClick) {
        if (listClick.read && !checkEmpty(dataId)) {
          params.dataFunction["viewListClick"] = (...arg: any) => {
            if (listClick.read) {
              listClick.read(getListClickArg(listClick.readFetch ?? listClickFetch, ...arg));
            }
          };
        }
        if (listClick.create) {
          params.dataFunction["writeListClick"] = (...arg: any) => {
            if (listClick.create) {
              listClick.create(getListClickArg(listClick.createFetch ?? listClickFetch, ...arg));
            }
          };
        } else if (listClick.edit) {
          params.dataFunction["writeListClick"] = (...arg: any) => {
            if (listClick.edit) {
              listClick.edit(getListClickArg(listClick.editFetch ?? listClickFetch, ...arg));
            }
          };
        }
        if (listClick.read && !checkEmpty(dataId)) {
          params.dataFunction["viewListClick"] = (...arg: any) => {
            if (listClick.read) {
              listClick.read(getListClickArg(listClick.readFetch ?? listClickFetch, ...arg));
            }
          };
        }
        if (listClick.update) {
          params.dataFunction["editListClick"] = (...arg: any) => {
            if (listClick.update) {
              listClick.update(getListClickArg(listClick.updateFetch ?? listClickFetch, ...arg));
            }
          };
        } else if (listClick.edit) {
          params.dataFunction["editListClick"] = (...arg: any) => {
            if (listClick.edit) {
              listClick.edit(getListClickArg(listClick.editFetch ?? listClickFetch, ...arg));
            }
          };
        }
      }
    }

    if (params.listClick) {
      const listClick = params.listClick;
      const listClickFetch = params.listClickFetch;
      if (listClick instanceof Function) {
        if (dataMode !== "view" || (dataMode === "view" && !checkEmpty(dataId)))
          params.dataFunction[dataMode + "ListClick"] = (...arg: any) => {
            listClick(getListClickArg(listClickFetch, ...arg));
          };
      } else if (listClick) {
        if (listClick.read && !checkEmpty(dataId)) {
          params.dataFunction["viewListClick"] = (...arg: any) => {
            if (listClick.read) {
              listClick.read(getListClickArg(listClick.readFetch ?? listClickFetch, ...arg));
            }
          };
        }
        if (listClick.create) {
          params.dataFunction["writeListClick"] = (...arg: any) => {
            if (listClick.create) {
              listClick.create(getListClickArg(listClick.createFetch ?? listClickFetch, ...arg));
            }
          };
        } else if (listClick.edit) {
          params.dataFunction["writeListClick"] = (...arg: any) => {
            if (listClick.edit) {
              listClick.edit(getListClickArg(listClick.editFetch ?? listClickFetch, ...arg));
            }
          };
        }
        if (listClick.read && !checkEmpty(dataId)) {
          params.dataFunction["viewListClick"] = (...arg: any) => {
            if (listClick.read) {
              listClick.read(getListClickArg(listClick.readFetch ?? listClickFetch, ...arg));
            }
          };
        }
        if (listClick.update) {
          params.dataFunction["editListClick"] = (...arg: any) => {
            if (listClick.update) {
              listClick.update(getListClickArg(listClick.updateFetch ?? listClickFetch, ...arg));
            }
          };
        } else if (listClick.edit) {
          params.dataFunction["editListClick"] = (...arg: any) => {
            if (listClick.edit) {
              listClick.edit(getListClickArg(listClick.editFetch ?? listClickFetch, ...arg));
            }
          };
        }
      }
    }

    if (params.listCancel) {
      const listCancel = params.listCancel;
      const listCancelFetch = params.listCancelFetch;
      if (listCancel instanceof Function) {
        if (dataMode !== "view" || (dataMode === "view" && !checkEmpty(dataId)))
          params.dataFunction[dataMode + "ListCancel"] = (...arg: any) => {
            listCancel(getListClickArg(listCancelFetch, ...arg));
          };
      } else if (listCancel) {
        if (listCancel.read && !checkEmpty(dataId)) {
          params.dataFunction["viewListCancel"] = (...arg: any) => {
            if (listCancel.read) {
              listCancel.read(getListClickArg(listCancel.readFetch ?? listCancelFetch, ...arg));
            }
          };
        }
        if (listCancel.create) {
          params.dataFunction["writeListCancel"] = (...arg: any) => {
            if (listCancel.create) {
              listCancel.create(getListClickArg(listCancel.createFetch ?? listCancelFetch, ...arg));
            }
          };
        } else if (listCancel.edit) {
          params.dataFunction["writeListCancel"] = (...arg: any) => {
            if (listCancel.edit) {
              listCancel.edit(getListClickArg(listCancel.editFetch ?? listCancelFetch, ...arg));
            }
          };
        }
        if (listCancel.read && !checkEmpty(dataId)) {
          params.dataFunction["viewListCancel"] = (...arg: any) => {
            if (listCancel.read) {
              listCancel.read(getListClickArg(listCancel.readFetch ?? listCancelFetch, ...arg));
            }
          };
        }
        if (listCancel.update) {
          params.dataFunction["editListCancel"] = (...arg: any) => {
            if (listCancel.update) {
              listCancel.update(getListClickArg(listCancel.updateFetch ?? listCancelFetch, ...arg));
            }
          };
        } else if (listCancel.edit) {
          params.dataFunction["editListCancel"] = (...arg: any) => {
            if (listCancel.edit) {
              listCancel.edit(getListClickArg(listCancel.editFetch ?? listCancelFetch, ...arg));
            }
          };
        }
      }
    }
  }

  //const

  const memoparams = useMemo(() => {
    return {
      articleParam: params.articleParam,
      dataId: params.dataId !== undefined ? params.dataId.toString() : params.dataId,
      dataCols: params.dataCols,
      dataScrollTo: params.dataScrollTo,
      dataScrollMargin: params.dataScrollMargin,
      dataResultName: params.dataResultName,
      dataScrollAnimate: params.dataScrollAnimate,
      fetchHost: params.fetchHost,
      fetchUrl: params.fetchUrl,
      fetchUrlAfter: params.fetchUrlAfter,
      modeField: params.modeField,
      changeDataId: params.changeDataId,
      editCheck: params.editCheck,
      //      tempValue: params.tempValue !== undefined ? { ...params.tempValue } : {},
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    params.pathname,
    params.articleParam,
    params.changeDataId,
    params.dataCols,
    params.dataId,
    params.dataMode,
    params.dataResultName,
    params.dataScrollMargin,
    params.dataScrollTo,
    params.dataScrollAnimate,
    params.fetchHost,
    params.fetchUrl,
    params.fetchUrlAfter,
    params.modeField,
    params.editCheck,
    //    params.tempValue,
  ]);

  const [codeGroups, setCodeGroups] = useState<Record<string, any[]> | undefined | null>(params.codeGroups);
  const [groupList, setGroupList] = useState<string[]>([]);

  useEffect(() => {
    const getAppDataHandler = (event: MessageEvent) => {
      if (event.data?.type === "getAppData") {
        const vars = event.data.data as Record<string, any>;
        if (vars) {
          form.setFieldsValue(vars);
        }
      }
    };

    if (isNativePlatform) {
      window.addEventListener("message", getAppDataHandler);
    }
    if (typeof localStorage !== undefined) {
      const guide_type = localStorage.getItem(guide_type_name) as DataGuideType;
      if (guide_type && guide_type !== guideType) {
        setGuideType(guide_type);
      }
    }
    return () => {
      if (isNativePlatform) {
        window.removeEventListener("message", getAppDataHandler);
      }
      if (params.setTimer && params.timer) {
        params.setTimer({ timer: params.timer, start: undefined });
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (params.codeGroups === undefined) {
      const groups = getColsGroups(params.dataCols);
      if (groups) {
        if (groupList === undefined || groups.length !== groupList.length || groups.some((item) => !groupList.includes(item))) {
          Debug("change groups in data");
          //setCodeGroups(undefined);
          setGroupList(groups);
          getCodeGroups(groups, params.locale, setCodeGroups);
        }
      } else {
        setCodeGroups({});
      }
    } else {
      setCodeGroups(params.codeGroups);
    }
  }, [params.codeGroups, params.locale, params.dataCols, groupList, params.pathname]);

  useEffect(() => {
    if (!codeGroups) {
      return;
    }
    //Debug(codeGroups);
    // Debug(params.pathname, params.page.link, location.pathname);
    if (
      params.pathname &&
      location.pathname.indexOf(params.pathname) !== 0 &&
      params.page.link !== getMenuProps(location.pathname, params.user).page.link
    ) {
      init.current = false;
      // setInit(false);
      return;
    }
    const datapop = (e: any) => {
      Debug("datapop : ", e);
      const data_id = getDataId(memoparams.articleParam);
      const data_mode = getDataMode(data_id, undefined, params.defaultMode) ?? "";
      if (memoparams.changeDataId) {
        memoparams.changeDataId(data_id ?? "", params?.useDefaultId, data_mode, memoparams.modeField, false);
      }
    };
    const changePathname = pathname !== params.pathname;

    const data_id = getDataId(memoparams.articleParam);
    const nowDataMode = getDataMode(changePathname ? params.dataId : data_id, memoparams.modeField, params.defaultMode) ?? "view";
    if (params?.pageAuth?.view ?? true) {
      const forceInit = dataMode !== nowDataMode;
      const dataIdChange = dataId !== memoparams.dataId;
      Debug(
        "Run Use Effect Check - " +
          init.current +
          "," +
          dataId +
          typeof dataId +
          "," +
          memoparams.dataId +
          typeof memoparams.dataId +
          "|" +
          dataMode +
          "," +
          nowDataMode +
          "|" +
          changePathname +
          "," +
          forceInit +
          "," +
          dataIdChange +
          "," +
          reload,
      );

      if (changePathname || dataIdChange || forceInit || !init.current || reload) {
        const set_loading = dataIdChange || reload || nowDataMode === "view" || params.editReload || changePathname;
        if (reload) {
          setReload(false);
        }
        if (params.initFunction && params.initFunction.current === undefined) {
          // params.initFunction.current = [];
        }
        // Debug("Run Use Effect Pass - " + init + "," + dataId + "," + memoparams.dataId + "|" + dataMode + "," + nowDataMode);
        enableScroll();
        if (
          (params.useDefaultId || memoparams.dataId) &&
          memoparams.dataId !== "write" &&
          data_id !== "write" &&
          nowDataMode !== "write" &&
          memoparams.fetchUrl
        ) {
          Debug("Run Use Effect fetchUrl - " + init.current + "," + dataId + "," + memoparams.dataId + "|" + dataMode + "," + nowDataMode);

          runInit.current = false;
          // const forceInit = dataMode !== nowDataMode;
          // const dataIdChange = dataId !== memoparams.dataId;
          if (set_loading && !loading) {
            Debug("Read Set Loading true");
            setLoading(true);
          }

          const tempFetchUrl = getFetchUrlOption(
            memoparams.dataId,
            option,
            memoparams.fetchUrl,
            memoparams.fetchHost,
            memoparams.fetchUrlAfter,
            nowDataMode,
            params.listColLinkField,
            params.listColLinkFieldJoin,
            params.uriField,
            params.base64Field,
            params.checkDataMode,
          );
          clearPage(params);
          setDataLoading(true);

          fetchUtil(
            tempFetchUrl.url,
            tempFetchUrl.option,
            params.page.auth,
            (data: any) => {
              // let result: any[] | undefined;
              // if (data?.result != null) {
              //   if (memoparams.dataResultName != null && data.result[memoparams.dataResultName] != null) {
              //     result = data.result[memoparams.dataResultName];
              //   } else {
              //     result = data.result;
              //   }
              // }
              // const checklist = { is: "" };
              setDataLoading(false);
              const resultTarget =
                data?.result != null
                  ? memoparams.dataResultName != null && Object.keys(data.result).includes(memoparams.dataResultName)
                    ? memoparams.dataResultName
                    : undefined
                  : undefined;
              const result = data?.result != null ? (resultTarget ? data.result[resultTarget] : data.result) : undefined;
              if (result == null || result == undefined || (data.status !== "OK" && data.status !== "200")) {
                const nodata = t(data.description ?? fetchStatusText(data.status, params.user ? false : true));
                const result_nodata = getNoData(nodata, data);
                Debug("Fetch Data Error", data);
                setDataError(true);
                setCols(initDataCols({ nodata_field: { inputType: "display" } }));
                setData(() => {
                  return { nodata_field: result_nodata };
                }); //+ "-" + error.toString()
                setSubData({});
              } else {
                if (resultTarget) {
                  const mergeTarget = params.dataMerge
                    ? typeof params.dataMerge === "string"
                      ? [params.dataMerge]
                      : params.dataMerge
                    : undefined;
                  if (mergeTarget) {
                    mergeTarget.forEach((merge) => {
                      const merge_data = data.result[merge];
                      if (merge_data && merge_data instanceof Object) {
                        Object.keys(merge_data).forEach((key) => {
                          result[key] = merge_data[key];
                        });
                        delete data.result[merge];
                      }
                    });
                  }
                  Object.keys(data.result).forEach((key) => {
                    if (key !== resultTarget) {
                      result[key] = data.result[key];
                    }
                  });
                }
                Debug(result);
                Debug("Fetch Data", data);
                scrollToDataPosition(
                  containerId,
                  memoparams.dataScrollTo ?? dv.dataScrollTo,
                  undefined,
                  memoparams.dataScrollMargin,
                  memoparams.dataScrollAnimate,
                );
                if (memoparams.dataCols === null && result != null) {
                  const resultKeys = Object.keys(result);
                  const initCols = initDataCols(resultKeys);
                  // Debug(initCols);
                  // Debug(resultKeys);
                  // Debug(result);
                  setCols(() => {
                    return initCols;
                  });
                } else {
                  //Debug(cols);
                  if (dataError) {
                    setCols(initDataCols(memoparams.dataCols));
                  }
                }
                const check_sub_data: Record<string, any> = {};
                if (params.subData) {
                  const data_keys = typeof params.subData === "string" ? [params.subData] : params.subData;
                  if (data_keys.length > 0) {
                    data_keys.forEach((key) => {
                      if (data[key]) {
                        check_sub_data[key] = data[key];
                      }
                    });
                  }
                }
                setData(result);
                if ((nowDataMode === "view" || nowDataMode === "edit") && params?.pageAuth?.edit) {
                  const check = memoparams.editCheck;
                  Debug("edit check : ", check);
                  if (check === undefined || (typeof check === "boolean" && !check)) {
                    editCheck.current = true;
                  } else {
                    const check_field = typeof check === "boolean" ? "edit_check" : check;
                    const check_result = check_field instanceof Function ? check_field(result) : result[check_field];
                    editCheck.current = check_result ?? false;
                  }
                }
                setSubData(check_sub_data);
              }

              if (params.dataFunction && params.dataFunction["setHiddenAds"]) {
                const check_ads =
                  typeof params.hiddenAds === "boolean"
                    ? params.hiddenAds
                    : typeof params.hiddenAds === "string" && result
                      ? result[params.hiddenAds]
                        ? true
                        : false
                      : false;
                params.dataFunction["setHiddenAds"](check_ads);
              } else {
                Debug("setHiddenAds is null");
              }

              Debug(
                "Run Use Effect Check - init : " +
                  init.current +
                  ", dataId : " +
                  dataId +
                  ", memoparams.dataId : " +
                  memoparams.dataId +
                  ", dataMode : " +
                  dataMode +
                  ", nowDataMode : " +
                  nowDataMode +
                  ", changePathname : " +
                  changePathname,
              );

              if (!set_loading || checkEmpty(dataId) || dataIdChange) {
                Debug("Check Run data init!1");
                if (!runInit.current || forceInit || dataIdChange || (params.useDefaultId && checkEmpty(dataId))) {
                  setTimeout(() => {
                    Debug("Run data init!1");
                    if (params.resetClassList ?? true) {
                      Debug("reset ClassList");
                      setClassList(params.dataFormClassDefault ?? []);
                    }
                    Debug("Fetch set Loading false");
                    setLoading(false);
                    runInit.current = true;
                    if (params.dataInit) {
                      params.dataInit(result, { ...params, dataMode: nowDataMode }, "init");
                    }
                    if (params.initFunction) {
                      const tempInitFunction = params.initFunction?.current;
                      if (tempInitFunction && tempInitFunction.length > 0) {
                        Debug("data init!1 initFunction " + tempInitFunction.length);
                        tempInitFunction.forEach((func) => {
                          func();
                        });
                      }
                      params.initFunction.current = undefined;
                    }
                    // setTimeout(() => {
                    //   Debug("Form Memo", params.formMemo);
                    // }, 3000);
                  }, params.dataInitDelay ?? 150);
                } else {
                  Debug("Not Run data init!1");
                }
              } else {
                Debug("data !init !set loading - false");
                if (dataMode !== nowDataMode || set_loading) {
                  // setTimeout(() => {
                  //   if (params.resetClassList ?? true) {
                  //     Debug("reset ClassList");
                  //     setClassList(params.dataFormClassDefault ?? []);
                  //   }
                  // }, params.dataInitDelay ?? 150);
                  setLoading(false);
                }
                // setLoading(false);
              }
              setTimeout(() => {
                form.resetFields();
              }, 10);
            },
            (error: any) => {
              Debug(error);
              setDataError(true);
              setCols(initDataCols({ error_field: { inputType: "display" } }));
              setData({ error_field: t("error_text") }); //+ "-" + error.toString()
              setSubData({});
              setLoading(false);
              setDataLoading(false);
              if (params.dataFunction && params.dataFunction["setHiddenAds"]) {
                const check_ads = typeof params.hiddenAds === "boolean" ? params.hiddenAds : false;
                params.dataFunction["setHiddenAds"](check_ads);
              }
            },
          );
        } else {
          if (memoparams.dataId === "write" || nowDataMode === "write" || data_id === "write") {
            clearPage(params);
            runInit.current = false;
            if (memoparams.dataCols != null && dataError) {
              setCols(initDataCols(memoparams.dataCols));
            }
            // Debug("write", tempValue);
            if (changePathname) {
              setData(params.tempValue !== undefined ? { ...params.tempValue } : {});
            } else {
              setData(tempValue);
            }
            scrollToDataPosition(
              containerId,
              memoparams.dataScrollTo ?? dv.dataScrollTo,
              undefined,
              memoparams.dataScrollMargin,
              memoparams.dataScrollAnimate,
            );
            setTimeout(() => {
              form.resetFields();
              const checkId =
                !checkEmpty(data_id) && data_id !== "write"
                  ? getDataId(memoparams.articleParam)
                  : !checkEmpty(memoparams.dataId) && memoparams.dataId !== "write"
                    ? memoparams.dataId
                    : undefined;
              const matching = checkId ? (params.writeMatching ?? {}) : params.writeMatching;

              Debug("matching values", checkId, matching, dataId);
              if (matching) {
                const search = new URLSearchParams(window.location.search);
                const values: Record<string, any> = {};
                const check_cols = getColsFields(memoparams.dataCols);
                Object.keys(matching).forEach((key) => {
                  if (search.has(key)) {
                    const col = check_cols[matching[key]];
                    // Debug(col);
                    if (col) {
                      values[matching[key]] = convertInputTypeValue(search.get(key), col.inputType, col.scale);
                    }
                  }
                });
                const joinStr = params.listColLinkFieldJoin ?? "_";
                const ids =
                  checkId && typeof checkId === "string" ? (checkId.indexOf(joinStr) > 0 ? checkId.split(joinStr) : [checkId]) : undefined;
                if (ids && params.listColLinkField) {
                  (typeof params.listColLinkField === "string" ? [params.listColLinkField] : params.listColLinkField).forEach(
                    (item, index) => {
                      values[item] = ids[index];
                    },
                  );
                }
                Debug("matching values", dataId, checkId, values);
                form.setFieldsValue(values);
              }
            }, 10);
            Debug("Write Set Loading true");
            setLoading(true);
            if (params.dataFunction && params.dataFunction["setHiddenAds"]) {
              const check_ads = typeof params.hiddenAds === "boolean" ? params.hiddenAds : true;
              params.dataFunction["setHiddenAds"](check_ads);
            }
            setTimeout(() => {
              Debug("Write Mode set Loading false");
              setLoading(false);
            }, 100);
          } else {
            if (params.dataFunction && params.dataFunction["setHiddenAds"]) {
              const check_ads = typeof params.hiddenAds === "boolean" ? params.hiddenAds : false;
              params.dataFunction["setHiddenAds"](check_ads);
            }
          }
        }

        if (changePathname || !init.current) {
          const initCols = initDataCols(memoparams.dataCols);
          const check_cols = getColsFields(memoparams.dataCols);
          const selectWithLoad: string[] = [];
          Object.keys(check_cols).map((key) => {
            const selectWithLoadArr = [
              check_cols[key].selectWithLoad,
              check_cols[key].read?.selectWithLoad,
              check_cols[key].create?.selectWithLoad,
              check_cols[key].edit?.selectWithLoad,
              check_cols[key].update?.selectWithLoad,
            ];
            selectWithLoadArr.forEach((obj) => {
              if (obj) {
                const checkArr = typeof obj === "string" ? [obj] : obj;
                checkArr.forEach((item) => {
                  if (!selectWithLoad.includes(item)) {
                    selectWithLoad.push(item);
                  }
                });
              }
            });
          });
          Debug("selectWithLoad List : ", selectWithLoad);
          setSelectWithFields(selectWithLoad);
          setCols(initCols);
          if (changePathname) {
            setPathname(params.pathname);
            setTempValue(params.tempValue !== undefined ? { ...params.tempValue } : {});
            if (params.dataFunction) {
              const listClick = params.listClick;
              const listClickFetch = params.listClickFetch;
              if (params.dataFunction["viewListClick"] && checkEmpty(dataId)) {
                delete params.dataFunction["viewListClick"];
              } else if (listClick) {
                if (listClick instanceof Function) {
                  params.dataFunction["viewListClick"] = (...arg: any) => {
                    listClick(getListClickArg(listClickFetch, ...arg));
                  };
                } else if (listClick.read) {
                  params.dataFunction["viewListClick"] = (...arg: any) => {
                    if (listClick.read) {
                      listClick.read(getListClickArg(listClick.readFetch ?? listClickFetch, ...arg));
                    }
                  };
                }
              }
            }
          }
          if (!init.current) {
            init.current = true;
          } else {
            // window.removeEventListener("popstate", datapop);
          }
        }

        if (dataId !== memoparams.dataId) {
          setDataId(memoparams.dataId);
        }
      }

      if (dataMode !== nowDataMode) {
        editCheck.current = false;
        setDataMode(nowDataMode);
      }
    } else {
      const dataText = getDataStatusText();
      setDataError(true);
      setCols(initDataCols({ error_field: { inputType: "display" } }));
      setData({ error_field: t(dataText) });
      setSubData({});
      setLoading(false);
      editCheck.current = false;
    }
    if (!params.useDatalist) {
      window.addEventListener("popstate", datapop);
    }
    return () => {
      if (!params.useDatalist) {
        window.removeEventListener("popstate", datapop);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    t,
    option,
    containerId,
    // dataId,
    dataMode,
    dataError,
    // memoparams,
    form,
    codeGroups,
    reload,
    params.page,
    params.dataId,
    params.dataMode,
    params.useDefaultId,
    params.pageAuth?.view,
    params.pageAuth?.edit,
    params.defaultMode,
    params.subData,
    params.writeMatching,
    params.listColLinkField,
    params.listColLinkFieldJoin,
    params.user,
  ]);

  // const subListSet = () => {
  //   const cols = getColsFields(params.dataCols);
  //   Object.keys(cols).forEach((key) => {
  //     const col = cols[key];
  //     const subListTarget = getSubListTarget(col, key);
  //     if (col.subList && subListTarget) {

  //       const subListData = data[subListTarget];
  //     }
  //   });
  // };

  useEffect(() => {
    // Debug("data init!2", { loading, dataLoading, init, dataId });
    if (!loading && !dataLoading && init) {
      setTempData({});
      const listClick = params.listClick;
      const listClickFetch = params.listClickFetch;
      if (params.dataFunction) {
        if (params.dataFunction["viewListClick"] && checkEmpty(dataId)) {
          delete params.dataFunction["viewListClick"];
        } else if (listClick) {
          if (listClick instanceof Function) {
            params.dataFunction["viewListClick"] = (...arg: any) => {
              listClick(getListClickArg(listClickFetch, ...arg));
            };
          } else if (listClick.read) {
            params.dataFunction["viewListClick"] = (...arg: any) => {
              if (listClick.read) {
                listClick.read(getListClickArg(listClick.readFetch ?? listClickFetch, ...arg));
              }
            };
          }
        }
      }

      // if (!dataLoading && init) {
      Debug("data init!2 Check", {
        loading,
        dataLoading,
        init,
        runinit: runInit.current,
        dataId,
        initFunction: params.initFunction?.current,
      });
      if (
        (params.dataInit && dataId === "write") ||
        dataId !== "" ||
        (dataId === "" && params.defaultMode === "write") ||
        (params.initFunction && params.initFunction.current && params.initFunction.current.length > 0)
      ) {
        if (!runInit.current) {
          setTimeout(() => {
            Debug("Run data init!2 Start", { loading, dataLoading, init, dataId });
            runInit.current = true;
            if (params.resetClassList ?? true) {
              Debug("reset ClassList");
              setClassList(params.dataFormClassDefault ?? []);
            }
            if (params.dataInit) {
              params.dataInit(data, { ...params, dataMode: dataMode }, "init");
            }
            if (params.initFunction) {
              const tempInitFunction = params.initFunction?.current;
              if (tempInitFunction && tempInitFunction.length > 0) {
                Debug("data init!2 initFunction " + tempInitFunction.length);
                tempInitFunction.forEach((func) => {
                  func();
                });
              }
              params.initFunction.current = undefined;
            }
          }, params.dataInitDelay ?? 150);
        }
      } else {
        if (params.initFunction) {
          const tempInitFunction = params.initFunction?.current;
          if (tempInitFunction && tempInitFunction.length > 0) {
            Debug("data init!2 initFunction " + tempInitFunction.length);
            tempInitFunction.forEach((func) => {
              func();
            });
          }
          params.initFunction.current = undefined;
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, init, dataId, pathname]);

  useEffect(() => {
    setTempValue(params.tempValue !== undefined ? { ...params.tempValue } : {});
  }, [params.tempValue]);

  const [clipboardChange, setClipboardChange] = useState(false);
  const [user_clipboard, setUserClipboard] = useState<string | undefined>(undefined);

  const clipboard:
    | {
        paste?: ClipboardPropCommon;
        copy?: ClipboardPropCommon;
        clear?: ClipboardPropCommon;
        trash?: ClipboardPropCommon;
        copyMatching?: Record<string, string>;
        pasteMatching?: Record<string, Record<string, string> | string[]> | string[];
        flexClassName?: string;
        front?: boolean | "both";
        use_paste: boolean;
        use_trash: boolean;
      }
    | undefined = useMemo(() => {
    if (clipboardChange) {
      setClipboardChange(false);
      return undefined;
    }
    //Debug("변경사항 확인");
    const temp_clipboard:
      | (ClipboardPropCommon & {
          paste?: ClipboardPropCommon | boolean;
          copy?: ClipboardPropCommon | boolean;
          clear?: ClipboardPropCommon | boolean;
          trash?: ClipboardPropCommon | boolean;
          flexClassName?: string;
          front?: boolean | "both";
        })
      | undefined =
      typeof params.clipboard === "boolean"
        ? params.clipboard
          ? {}
          : undefined
        : typeof params.clipboard === "string"
          ? { category: params.clipboard }
          : params.clipboard;
    if (!temp_clipboard) {
      return undefined;
    } else {
      const clipboard_copy = {
        category: temp_clipboard.category,
        exField: temp_clipboard.exField,
        inField: temp_clipboard.inField,
        load: temp_clipboard.load,
      };
      const copy: ClipboardProp | undefined =
        temp_clipboard.copy === undefined || (typeof temp_clipboard.copy === "boolean" && temp_clipboard.copy)
          ? clipboard_copy
          : typeof temp_clipboard.copy === "boolean"
            ? undefined
            : temp_clipboard.copy;
      const trash: ClipboardProp | undefined =
        temp_clipboard.trash === undefined || (typeof temp_clipboard.trash === "boolean" && temp_clipboard.trash)
          ? clipboard_copy
          : typeof temp_clipboard.trash === "boolean"
            ? undefined
            : temp_clipboard.trash;
      const paste: ClipboardProp | undefined =
        dataMode === "write" || dataMode === "edit"
          ? temp_clipboard.paste === undefined || (typeof temp_clipboard.paste === "boolean" && temp_clipboard.paste)
            ? clipboard_copy
            : typeof temp_clipboard.paste === "boolean"
              ? undefined
              : temp_clipboard.paste
          : undefined;
      const clear: ClipboardProp | undefined =
        dataMode === "write" || dataMode === "edit"
          ? temp_clipboard.clear === undefined || (typeof temp_clipboard.clear === "boolean" && temp_clipboard.clear)
            ? clipboard_copy
            : typeof temp_clipboard.clear === "boolean"
              ? undefined
              : temp_clipboard.clear
          : undefined;

      const paste_category = paste?.category ?? temp_clipboard.category;
      const trash_category = trash?.category ?? temp_clipboard.category;
      const user_clipboard_obj = paste || trash ? getJsonFromStr(user_clipboard) : undefined;
      const paste_storage =
        paste && navigator ? getJsonFromStr(localStorage.getItem("clipboard" + (paste_category ? "_" + paste_category : ""))) : undefined;
      const trash_storage =
        trash && navigator ? getJsonFromStr(localStorage.getItem("clipboard" + (trash_category ? "_" + trash_category : ""))) : undefined;

      const paste_matching = paste?.pasteMatching ?? temp_clipboard.pasteMatching;
      const paste_matching_has =
        navigator && paste_matching
          ? (paste_matching instanceof Array ? paste_matching : Object.keys(paste_matching)).some((temp_category) => {
              const json = getJsonFromStr(localStorage.getItem("clipboard" + (temp_category ? "_" + temp_category : "")));
              return json !== undefined;
            })
          : false;

      // Debug(paste_matching_has);

      const use_paste =
        paste_storage !== undefined ||
        (user_clipboard_obj !== undefined &&
          ((checkEmpty(paste_category) && (checkEmpty(user_clipboard_obj.category) || checkEmpty(paste_category))) ||
            paste_category === user_clipboard_obj.category)) ||
        paste_matching_has;
      const use_trash =
        trash_storage !== undefined ||
        (user_clipboard_obj !== undefined &&
          ((checkEmpty(trash_category) && (checkEmpty(user_clipboard_obj.category) || checkEmpty(trash_category))) ||
            trash_category === user_clipboard_obj.category));

      //navigator.clipboard.readText()
      if (copy || paste || clear || trash) {
        return {
          copy,
          paste,
          clear,
          trash,
          copyMatching: temp_clipboard.copyMatching,
          pasteMatching: temp_clipboard.pasteMatching,
          flexClassName: temp_clipboard.flexClassName,
          front: temp_clipboard.front,
          use_paste,
          use_trash,
        };
      } else {
        return undefined;
      }
    }
  }, [dataMode, params.clipboard, clipboardChange, user_clipboard]);

  useEffect(() => {
    if (clipboard?.paste && navigator && "clipboard" in navigator && navigator.clipboard) {
      try {
        if (document.hasFocus()) {
          // navigator.clipboard.readText().then((value) => {
          //   setUserClipboard(checkEmptyValue(value));
          // });
        }
      } catch {}
    }
  }, [dataId, clipboard?.paste]);

  //Debug("change data");
  //Debug(data);
  // Debug(params);
  // Debug(dataMode);
  // Debug(cols);

  const Clipboard = ({ clipClassName }: { clipClassName?: string }) => {
    if (
      (params.useGuide ?? true) ||
      (clipboard &&
        (clipboard.copy || (clipboard.paste && clipboard.use_paste) || clipboard.clear || (clipboard.trash && clipboard.use_trash)))
    ) {
      const guideProp = params.useGuide && typeof params.useGuide !== "boolean" ? params.useGuide : undefined;
      return (
        <Flex
          align="end"
          // gap={params.gap}
          className={cn("ClipboardButtons", clipboard?.flexClassName ?? dv.clipboardButtonsFlexClassName, "max-w-full", clipClassName)}
        >
          {clipboard && clipboard.trash && clipboard.use_trash ? (
            <Skeleton loading={loading}>
              <Popconfirm
                title={ta("trash")}
                description={ta("clipboard_trash")}
                placement={clipboard.trash.popconfirmPlacement ?? "leftTop"}
                onConfirm={async () => {
                  const trash = clipboard.trash;
                  const category = trash?.category ? "clipboard_" + trash?.category : "clipboard";
                  let changed = false;
                  if (trash && localStorage.getItem(category)) {
                    localStorage.removeItem(category);
                    changed = true; //setClipboardChange(true);
                  }
                  if (navigator && navigator.clipboard) {
                    const value = document.hasFocus() ? await navigator.clipboard.readText() : undefined;

                    const trash_category = trash?.category;
                    const user_clipboard_obj = getJsonFromStr(value);
                    if (
                      (checkEmpty(trash_category) && checkEmpty(user_clipboard_obj.category)) ||
                      (user_clipboard_obj !== undefined &&
                        user_clipboard_obj instanceof Object &&
                        trash_category === user_clipboard_obj.category)
                    ) {
                      await navigator.clipboard.writeText("");
                      setUserClipboard(undefined);
                      changed = true;
                    }
                  }

                  if (changed) {
                    setClipboardChange(true);
                  } else {
                    const alertP = alertContext.setProp;
                    if (alertP) {
                      setTimeout(() => {
                        alertP({
                          open: true,
                          title: ta("trash"),
                          description: ta("clipboard_trash_failed"),
                          useCancel: false,
                          useOk: true,
                          okFunction: () => {},
                        });
                      }, dv.setTimeoutDelay);
                    }
                  }
                }}
                //onCancel={cancel}
                okText={ta("ok")}
                cancelText={ta("cancel")}
              >
                <Button
                  type="button"
                  variant={clipboard.trash.buttonVariant ?? "outline"}
                  className={cn(clipboard.trash.buttonClassName ?? dv.clipboardCommonButtonClassName, "cursor-pointer")}
                  onClick={(e) => {}}
                  {...clipboard.trash.buttonProps}
                >
                  {clipboard.trash.buttonIcon === null ? (
                    ""
                  ) : clipboard.trash.buttonIcon ? (
                    <Icon {...clipboard.trash.buttonIcon} />
                  ) : dv.clipboardTrashButtonIcon ? (
                    <Icon {...dv.clipboardTrashButtonIcon} />
                  ) : (
                    ""
                  )}
                  {t(clipboard.trash.buttonTitle ?? "trash")}
                </Button>
              </Popconfirm>
            </Skeleton>
          ) : (
            ""
          )}
          {/* {clipboard.clear ? (
          <Skeleton loading={loading}>
            <Button
              type="button"
              variant={clipboard.clear.buttonVariant ?? "outline"}
              className={cn(clipboard.clear.buttonClassName ?? dv.clipboardCommonButtonClassName, "cursor-pointer")}
              onClick={(e) => {}}
              {...clipboard.clear.buttonProps}
            >
              {clipboard.clear.buttonIcon === null ? (
                ""
              ) : clipboard.clear.buttonIcon ? (
                <Icon {...clipboard.clear.buttonIcon} />
              ) : dv.clipboardClearButtonIcon ? (
                <Icon {...dv.clipboardClearButtonIcon} />
              ) : (
                ""
              )}
              {t(clipboard.clear.buttonTitle ?? "eraser")}
            </Button>
          </Skeleton>
        ) : (
          ""
        )} */}
          {clipboard && clipboard.paste && clipboard.use_paste ? (
            <Skeleton loading={loading}>
              <Button
                type="button"
                variant={clipboard.paste.buttonVariant ?? "outline"}
                className={cn(clipboard.paste.buttonClassName ?? dv.clipboardCommonButtonClassName, "cursor-pointer")}
                onClick={(e) => {
                  const paste = clipboard.paste;
                  const category = paste?.category ? "clipboard_" + paste?.category : "clipboard";
                  const org_values = getJsonFromStr(localStorage.getItem(category));
                  let paste_values = {};

                  if (navigator && !org_values && (clipboard.pasteMatching || paste?.pasteMatching)) {
                    const paste_matching = clipboard.pasteMatching ?? paste?.pasteMatching;
                    if (paste_matching) {
                      (paste_matching instanceof Array ? paste_matching : Object.keys(paste_matching)).forEach((temp_category) => {
                        const json = getJsonFromStr(localStorage.getItem("clipboard" + (temp_category ? "_" + temp_category : "")));
                        if (json !== undefined) {
                          paste_values = { ...paste_values, ...json };
                        }
                      });
                    }
                  }
                  Debug("paste", paste?.pasteMatching, org_values, paste_values);

                  const values = org_values ?? paste_values;

                  if (paste && !checkEmpty(values)) {
                    if (paste.inField) {
                      const inField = paste.inField;
                      Object.keys(values).forEach((key) => {
                        if (!inField.includes(key)) {
                          delete values[key];
                        }
                      });
                    }
                    if (paste.exField) {
                      const exField = paste.exField;
                      Object.keys(values).forEach((key) => {
                        if (exField.includes(key)) {
                          delete values[key];
                        }
                      });
                    }

                    const mating_values = getMatchingData(form, params.formMemo, values);
                    //Debug(mating_values, values);

                    form.setFieldsValue(mating_values);
                    if (params.dataInit) {
                      params.dataInit(values, params, "paste");
                    }
                    if (paste?.load) {
                      paste.load(values, form);
                    }
                    return;
                  }
                  const alertP = alertContext.setProp;
                  if (alertP) {
                    setTimeout(() => {
                      alertP({
                        open: true,
                        title: ta("paste"),
                        description: ta("clipboard_paste_failed"),
                        useCancel: false,
                        useOk: true,
                        okFunction: () => {},
                      });
                    }, dv.setTimeoutDelay);
                  }
                }}
                {...clipboard.paste.buttonProps}
              >
                {clipboard.paste.buttonIcon === null ? (
                  ""
                ) : clipboard.paste.buttonIcon ? (
                  <Icon {...clipboard.paste.buttonIcon} />
                ) : dv.clipboardPasteButtonIcon ? (
                  <Icon {...dv.clipboardPasteButtonIcon} />
                ) : (
                  ""
                )}
                {t(clipboard.paste.buttonTitle ?? "paste")}
              </Button>
            </Skeleton>
          ) : (
            ""
          )}
          {clipboard && clipboard.copy ? (
            <Skeleton loading={loading}>
              <Popconfirm
                title={ta("copy")}
                description={ta("copy_detail")}
                placement={clipboard.copy.popconfirmPlacement ?? "leftTop"}
                onConfirm={() => {
                  const copy = clipboard.copy;
                  const values = dataMode === "view" ? data : form.getFieldsValue(); //getJsonFromStr(getStrFromJson(form.getFieldsValue()));
                  const alertP = alertContext.setProp;

                  if (copy && values) {
                    if (copy.inField) {
                      const inField = copy.inField;
                      Object.keys(values).forEach((key) => {
                        if (!inField.includes(key)) {
                          delete values[key];
                        }
                      });
                    }
                    if (copy.exField) {
                      const exField = copy.exField;
                      Object.keys(values).forEach((key) => {
                        if (exField.includes(key)) {
                          delete values[key];
                        }
                      });
                    }
                    if (copy.copyMatching) {
                      const copyMatching = copy.copyMatching;
                      Object.keys(copyMatching).forEach((key) => {
                        const changeKey = copyMatching[key];
                        if (changeKey !== key) {
                          values[changeKey] = getJsonFromStr(getStrFromJson(values[key]));
                          delete values[key];
                        }
                      });
                    }
                    const removes = ["rgst_by", "rgst_at", "rgst_user", "edit_by", "edit_at", "edit_user"];
                    removes.forEach((item) => {
                      delete values[item];
                    });

                    const scaled_values =
                      dataMode === "view" ? values : getScaledData(getColsFields(params.dataCols), values, dataMode, params.formFunction);
                    Debug(scaled_values);

                    if (scaled_values && Object.keys(scaled_values).length > 0) {
                      const save_str = getStrFromJson(scaled_values);
                      const category = copy.category;
                      if (save_str) {
                        localStorage.setItem(category ? "clipboard_" + category : "clipboard", save_str);
                        if (
                          navigator &&
                          navigator.clipboard
                          //  && params.user?.usertype &&
                          // (params.user.usertype.includes("SADMIN") ||
                          //   params.user.usertype.includes("ADMIN") ||
                          //   params.user.usertype.includes("TESTER"))
                        ) {
                          if (document.hasFocus()) {
                            try {
                              navigator.clipboard.writeText(`{${category ? `"category":"${category}",` : ""}"values":${save_str}}`);
                              if (alertP) {
                                setTimeout(() => {
                                  alertP({
                                    open: true,
                                    title: ta("copy"),
                                    description: ta("copy_ok"),
                                    useCancel: false,
                                    useOk: true,
                                    okFunction: () => {
                                      alertP(alertClose);
                                      setClipboardChange(true);
                                    },
                                  });
                                }, dv.setTimeoutDelay);
                              }
                            } catch (e) {}
                          }
                        }

                        return;
                      }
                    }
                  }

                  if (alertP) {
                    setTimeout(() => {
                      alertP({
                        open: true,
                        title: ta("copy"),
                        description: ta("copy_failed"),
                        useCancel: false,
                        useOk: true,
                        okFunction: () => {},
                      });
                    }, dv.setTimeoutDelay);
                  }
                }}
                //onCancel={cancel}
                okText={ta("ok")}
                cancelText={ta("cancel")}
              >
                <Button
                  type="button"
                  variant={clipboard.copy.buttonVariant ?? "outline"}
                  className={cn(clipboard.copy.buttonClassName ?? dv.clipboardCommonButtonClassName, "cursor-pointer")}
                  onClick={(e) => {}}
                  {...clipboard.copy.buttonProps}
                >
                  {clipboard.copy.buttonIcon === null ? (
                    ""
                  ) : clipboard.copy.buttonIcon ? (
                    <Icon {...clipboard.copy.buttonIcon} />
                  ) : dv.clipboardCopyButtonIcon ? (
                    <Icon {...dv.clipboardCopyButtonIcon} />
                  ) : (
                    ""
                  )}
                  {t(clipboard.copy.buttonTitle ?? "copy")}
                </Button>
              </Popconfirm>
            </Skeleton>
          ) : (
            ""
          )}
          {(params.useGuide ?? true) ? (
            <Skeleton loading={loading}>
              <Button
                type="button"
                variant={
                  guideProp?.buttonVariant ??
                  (guideType === "FULL" ? (useGuideSimple ? "solid" : "soft") : guideType === "SIMPLE" ? "soft" : "outline")
                }
                className={cn(guideProp?.buttonClassName ?? dv.clipboardCommonButtonClassName, "cursor-pointer")}
                onClick={(e) => {
                  setGuideType((prev) => {
                    let str: DataGuideType = "FULL";
                    switch (prev) {
                      case "FULL":
                        str = useGuideSimple ? "SIMPLE" : "NONE";
                        break;
                      case "SIMPLE":
                        str = "NONE";
                        break;
                      default:
                        str = "FULL";
                        break;
                    }
                    if (str === "FULL") {
                      localStorage.removeItem(guide_type_name);
                    } else {
                      localStorage.setItem(guide_type_name, str);
                    }
                    return str;
                  });
                }}
                {...guideProp?.buttonProps}
              >
                {guideProp?.buttonIcon === null ? (
                  ""
                ) : guideProp?.buttonIcon ? (
                  <Icon weight="bold" {...guideProp?.buttonIcon} />
                ) : dv.guideButtonIcon ? (
                  <Icon weight="bold" {...dv.guideButtonIcon} />
                ) : (
                  ""
                )}
                {t(guideProp?.buttonTitle ?? "guide")}
              </Button>
            </Skeleton>
          ) : (
            ""
          )}
        </Flex>
      );
    } else {
      return <></>;
    }
  };
  return (
    <Container
      id={containerId}
      className={cn(
        containerId,
        params.dataClassName ?? dv.dataClassName,
        "data-mode-" + dataMode,
        dataMode != "view" ? "edit-mode" : "",
        params.useDefaultId || dataId ? "" : "hidden",
      )}
    >
      <Form
        form={form}
        name={formName}
        onFinish={dataFormFinish}
        className={cn(params.dataFormClassName, classList, guideType === "NONE" ? "" : "GUIDE_" + guideType)}
        autoComplete={checkSafari ? "false" : undefined}
      >
        {clipboard && (clipboard.front ?? true) ? <Clipboard clipClassName="mb-4" /> : ""}
        <DataList.Root
          orientation={params.dataRootOrientation ?? dv.dataRootOrientation}
          size={params.dataRootSize ?? dv.dataRootSize}
          trim={params.dataRootTrim}
        >
          {params.useDefaultId || dataId
            ? cols.sort(sortDataColumn).map((col, index) => {
                const value = data ? data[typeof col.fieldId === "string" ? col.fieldId : col.field] : undefined;
                if (
                  !checkDisplay({
                    ...col,
                    value: value,
                    values: data,
                    userType: params.user?.usertype,
                    userAuth: params.pageAuth?.userAuth,
                  }) &&
                  col.display !== "change"
                ) {
                } else {
                  const inputName = col.field; //dataName + col.field;
                  return (
                    <DataInput
                      key={dataName + col.field}
                      form={form}
                      value={value}
                      values={data}
                      subValues={subData}
                      inputMode={dataMode}
                      loading={loading}
                      id={dataName + inputName}
                      name={inputName}
                      pathname={pathname}
                      selectWithFields={selectWithFields}
                      setValuesField={params.setValuesField}
                      setValueList={params.setValueList}
                      setSubData={setSubData}
                      formMemo={params.formMemo}
                      formFunction={params.formFunction}
                      labelUse={params.dataLabelUse}
                      labelTransition={params.dataLabelTransition}
                      initFunction={params.initFunction}
                      resetFunction={resetFunction.current}
                      setTimer={params.setTimer}
                      locale={params.locale}
                      codeGroups={codeGroups}
                      dataGuideType={guideType}
                      userSeq={params.user?.userseq}
                      userType={params.user?.usertype}
                      userAuth={params.pageAuth?.userAuth}
                      {...col}
                    />
                  );
                }
              })
            : ""}
        </DataList.Root>
        {clipboard && (!(clipboard.front ?? true) || clipboard.front === "both") ? <Clipboard clipClassName="mt-4" /> : ""}
        {(params.dataButtons ?? true) ? (
          <Flex
            align="end"
            // gap={params.gap}
            className={cn(params.dataButtonsFlexClassName ?? dv.dataButtonsFlexClassName, " max-w-full DownloadHidden")}
          >
            {(params.listButton ?? true) &&
            (dataMode ?? "view") === "view" &&
            (params?.useList ?? true) &&
            (params?.pageAuth?.listview ?? true) ? (
              <Skeleton loading={loading}>
                <Button
                  type="button"
                  variant="soft"
                  className={cn(params.listButtonClassName ?? dv.dataListCommonButtonClassName, "cursor-pointer")}
                  onClick={(e) => {
                    listPage(params.useDefaultId ?? false, params.changeDataId, dataId, params.modeField, params.historyPush);
                  }}
                  {...params.listButtonProps}
                >
                  {params.listButtonIcon === null ? (
                    ""
                  ) : params.listButtonIcon ? (
                    <Icon {...params.listButtonIcon} />
                  ) : dv.listButtonIcon ? (
                    <Icon {...dv.listButtonIcon} />
                  ) : (
                    ""
                  )}
                  {t(params.listButtonTitle ?? "list")}
                </Button>
              </Skeleton>
            ) : (
              ""
            )}
            {(params.removeButton ?? false) && (dataMode ?? "view") == "view" && (params?.pageAuth?.remove ?? false) ? (
              <Skeleton loading={loading}>
                <Popconfirm
                  title={ta("delete")}
                  description={ta("delete_detail")}
                  onConfirm={() => {
                    setTimeout(() => {
                      removeData(ta, form, params, alertContext);
                    }, 100);
                  }}
                  //onCancel={cancel}
                  okText={ta("ok")}
                  cancelText={ta("cancel")}
                >
                  <Button
                    type="button"
                    variant="soft"
                    className={cn(params.removeButtonClassName ?? dv.dataListCommonButtonClassName, "cursor-pointer")}
                    onClick={(e) => {
                      //removeData(ta, form, params);
                    }}
                    {...params.removeButtonProps}
                  >
                    {params.removeButtonIcon === null ? (
                      ""
                    ) : params.removeButtonIcon ? (
                      <Icon {...params.removeButtonIcon} />
                    ) : dv.removeButtonIcon ? (
                      <Icon {...dv.removeButtonIcon} />
                    ) : (
                      ""
                    )}
                    {t(params.removeButtonTitle ?? "remove")}
                  </Button>
                </Popconfirm>
              </Skeleton>
            ) : (
              ""
            )}
            {editCheck.current && (params.editButton ?? true) && (dataMode ?? "view") == "view" && (params?.pageAuth?.edit ?? false) ? (
              <Skeleton loading={loading}>
                <Button
                  type="button"
                  variant="soft"
                  className={cn(params.editButtonClassName ?? dv.dataListCommonButtonClassName, "cursor-pointer")}
                  onClick={(e) => {
                    editPage(params.useDefaultId ?? false, params.changeDataId, dataId, params.modeField, params.historyPush);
                  }}
                  {...params.editButtonProps}
                >
                  {params.editButtonIcon === null ? (
                    ""
                  ) : params.editButtonIcon ? (
                    <Icon {...params.editButtonIcon} />
                  ) : dv.editButtonIcon ? (
                    <Icon {...dv.editButtonIcon} />
                  ) : (
                    ""
                  )}
                  {t(params.editButtonTitle ?? "edit")}
                </Button>
              </Skeleton>
            ) : (
              ""
            )}
            {(params.cancelButton ?? true) &&
            (((dataMode ?? "view") == "write" && (params?.pageAuth?.write ?? false)) ||
              ((dataMode ?? "view") == "edit" && (params?.pageAuth?.edit ?? false))) ? (
              <Skeleton loading={loading}>
                <Button
                  type="button"
                  variant="soft"
                  className={cn(params.cancelButtonClassName ?? dv.dataListCommonButtonClassName, "cursor-pointer")}
                  onClick={(e) => {
                    if (params.setTimer && params.timer) {
                      params.setTimer({ timer: params.timer, start: undefined });
                    }
                    if (params.formMemo) {
                      const keys = Object.keys(params.formMemo);
                      keys.forEach((key) => {
                        if (params.formMemo) {
                          delete params.formMemo[key];
                        }
                      });
                    }
                    if (params.cancelButtonFunction) {
                      if (typeof params.cancelButtonFunction === "string") {
                        appRouterPush(router, params.cancelButtonFunction);
                        // router.push(params.cancelButtonFunction);
                      } else if (params.cancelButtonFunction instanceof Function) {
                        params.cancelButtonFunction();
                      }
                    } else {
                      viewPage(form, params.useDefaultId ?? false, params.changeDataId, dataId, params.modeField, params.historyPush);
                    }
                  }}
                  {...params.cancelButtonProps}
                >
                  {params.cancelButtonIcon === null ? (
                    ""
                  ) : params.cancelButtonIcon ? (
                    <Icon {...params.cancelButtonIcon} />
                  ) : dv.cancelButtonIcon ? (
                    <Icon {...dv.cancelButtonIcon} />
                  ) : (
                    ""
                  )}
                  {t(params.cancelButtonTitle ?? "cancel")}
                </Button>
              </Skeleton>
            ) : (
              ""
            )}
            {(params.undoButton ?? true) &&
            (((dataMode ?? "view") === "write" && (params?.pageAuth?.write ?? false)) ||
              (editCheck.current && (dataMode ?? "view") == "edit" && (params?.pageAuth?.edit ?? false))) ? (
              <Skeleton loading={loading}>
                <Button
                  type="button"
                  variant="soft"
                  className={cn(params.undoButtonClassName ?? dv.dataListCommonButtonClassName, "cursor-pointer")}
                  onClick={(e) => {
                    if (params.setTimer && params.timer) {
                      params.setTimer({ timer: params.timer, start: undefined });
                    }
                    //undo시 삭제해야 할 데이터를 파악할 것 - 일단 now
                    if (params.formMemo) {
                      const temp = params.formMemo;
                      Object.keys(temp).map((item) => {
                        if (temp[item].now !== null && temp[item].now !== undefined) {
                          delete temp[item].now;
                        }
                      });
                    }
                    undoData(form, cols);
                    if (resetFunction.current) {
                      Object.keys(resetFunction.current).forEach((key) => {
                        if (resetFunction.current[key] instanceof Function) {
                          resetFunction.current[key]();
                        }
                      });
                    }
                    const dataInit = params.dataInit;
                    if (dataInit) {
                      setTimeout(() => {
                        dataInit(data, params, "undo");
                      }, dv.setTimeoutDelay);
                    }
                  }}
                  {...params.undoButtonProps}
                >
                  {params.undoButtonIcon === null ? (
                    ""
                  ) : params.undoButtonIcon ? (
                    <Icon {...params.undoButtonIcon} />
                  ) : dv.undoButtonIcon ? (
                    <Icon {...dv.undoButtonIcon} />
                  ) : (
                    ""
                  )}
                  {t(params.undoButtonTitle ?? "undo")}
                </Button>
              </Skeleton>
            ) : (
              ""
            )}
            {(params.saveButton ?? true) &&
            (((dataMode ?? "view") == "write" && (params?.pageAuth?.write ?? false)) ||
              (editCheck.current && (dataMode ?? "view") == "edit" && (params?.pageAuth?.edit ?? false))) ? (
              <Skeleton loading={loading}>
                <Button
                  type="button"
                  variant="soft"
                  className={cn(params.saveButtonClassName ?? dv.dataListCommonButtonClassName, "cursor-pointer")}
                  onClick={(e) => {
                    if (params.setTimer && params.timer) {
                      params.setTimer({ timer: params.timer, start: undefined });
                    }
                    // if (params.formMemo) {
                    //   const keys = Object.keys(params.formMemo);
                    //   keys.forEach((key) => {
                    //     if (params.formMemo) {
                    //       delete params.formMemo[key];
                    //     }
                    //   });
                    // }
                    saveData(form);
                  }}
                  {...params.saveButtonProps}
                >
                  {params.saveButtonIcon === null ? (
                    ""
                  ) : params.saveButtonIcon ? (
                    <Icon {...params.saveButtonIcon} />
                  ) : dv.saveButtonIcon ? (
                    <Icon {...dv.saveButtonIcon} />
                  ) : (
                    ""
                  )}
                  {t(params.saveButtonTitle ?? "save")}
                </Button>
              </Skeleton>
            ) : (
              ""
            )}
            {(dataMode ?? "view") !== "write" && (params.dataReloadButton ?? true) ? (
              <Skeleton loading={loading}>
                <Button
                  type="button"
                  variant="soft"
                  className={cn(params.dataReloadButton ?? dv.dataListCommonButtonClassName, "cursor-pointer")}
                  onClick={(e) => {
                    setReload(true);
                    //writePage();
                  }}
                  {...params.dataReloadButtonProps}
                >
                  {params.dataReloadButtonIcon === null ? (
                    ""
                  ) : params.dataReloadButtonIcon ? (
                    <Icon {...params.dataReloadButtonIcon} />
                  ) : dv.dataReloadButtonIcon ? (
                    <Icon {...dv.dataReloadButtonIcon} />
                  ) : (
                    ""
                  )}
                  {t(params.dataReloadButtonTitle ?? "reload")}
                </Button>
              </Skeleton>
            ) : (
              ""
            )}
          </Flex>
        ) : (
          ""
        )}
      </Form>
    </Container>
  );
}
